import { render } from "./LottiePlayer.vue?vue&type=template&id=276091dc"
import script from "./LottiePlayer.vue?vue&type=script&lang=js"
export * from "./LottiePlayer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__